import { render, staticRenderFns } from "./AccountingReports.vue?vue&type=template&id=9d284ef0"
import script from "./AccountingReports.vue?vue&type=script&lang=js"
export * from "./AccountingReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports